export const PaymentAlternativeChoice = Object.freeze(
    {
        "vip_payment": 100,
        "externally_paid": 101,
        "free_payment": 102,
        "paid_trough_reseller": 103,
        "swish_directly": 1,
        "swish_via_swedbank_pay": 2,
        "vipps_via_swedbank_pay": 3,
        "mobile_pay_via_swedbank_pay": 4,
        "card_via_swedbank_pay": 5,
        "bank_transaction_via_swedbank_pay": 6,
    });

export function isFreeAlternativeChoice(choice) {
        return 100 <= choice && choice < 150;
}